import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg36Close = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 36"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(.25)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h36v36H0z"
      }), /*#__PURE__*/jsx("circle", {
        cx: 18,
        cy: 18,
        r: 14,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.52
      }), /*#__PURE__*/jsx("path", {
        d: "M9 9h18v18H9z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M12.935 13.15a.64.64 0 0 0 .053.846l4.105 4.105-4.105 4.106a.641.641 0 0 0 .453 1.095l.084-.006a.64.64 0 0 0 .37-.182L18 19.008l4.105 4.106a.64.64 0 0 0 .907 0l.054-.06a.64.64 0 0 0-.054-.847l-4.105-4.106 4.105-4.105a.64.64 0 0 0 0-.907l-.06-.053a.64.64 0 0 0-.846.053L18 17.195l-4.105-4.106a.64.64 0 0 0-.907 0z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg36Close$1 = Svg36Close;

export { Svg36Close$1 as default };
